import Email2 from './Email2'
export default Email2
